<template>
<div class="chapter">
<div class="inner_page">
<p class="front-title"><a id="page_viii"></a><a id="page_ix"></a><b>Dedication</b></p>
<p class="center">For my wife Jacqui, and for my children Isla, Rory and Finn, with all my love.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_dedication.vue?ad4307ee